import React from "react";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import productType from "../../assets/img/product-type-icon.svg";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import legacy from '../../assets/img/legacy-builder-img.png'
import newBuilder from '../../assets/img/new-builder-img.png'
const ProductTypeModal = (props) => {
  const { isOpen, onHide, showCreateProduct, setShowCreateProduct, callAllBrands } = props;
  const history = useHistory();
  const [showProductType, setShowProductType] = useState(false);
  const isModalOpen = useSelector((state) => state?.upgradeModalReducer?.open);
  const onClose = () => {
    setShowCreateProduct(null);
    // onHide()
  };
  const { basePath, slug } = useSelector((state) => state?.slugReducer);

  const showModal = (checkout) => {
    callAllBrands();
    setShowCreateProduct(checkout)
    // onHide()
    // history.push({
    //   pathname: `${basePath}/campaigns/addCampaigns`,
    //   state: { show: true, [checkout]: true }
    // })
  }
  return (
    <Modal centered className="new-modal template-modal" show={isOpen} onHide={onClose}>
      <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
        <div class="modal-header">
          Choose a Designer
          <button type="button" class="close" onClick={onClose} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className='templates-cont'>
            <div className="select-designer-container">
              <div className='d-flex flex-column gap-1'>
                <div>New (Beta)</div>
                <div className='fs-12px font-weight-400'>An advanced designer for more complex website designs</div>
                <button className='fs-12 mt-20px w-50 shadow-none text-nowrap project-blue-btn' onClick={() => showModal('pageBuilder')}> Continue </button>
              </div>
              <div>
                <img src={newBuilder} style={{objectFit:'contain'}} width={150} alt="" />
              </div>
            </div>
            <div className="select-designer-container">
              <div className='d-flex flex-column gap-1'>
                <div>Legacy</div>
                <div className='fs-12px font-weight-400'>Our legacy designer for simple website design without the fuss</div>
                <button className='fs-12 mt-20px w-50 shadow-none text-nowrap project-blue-btn' onClick={() => showModal('legacy')}> Continue </button>
              </div>
              <div>
                <img src={legacy} style={{objectFit:'contain'}} width={150} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {showCreateProduct && <Route path={basePath + "/campaigns/:addCampaign"} children={() => <ProductMain from={"template"} showCreateProduct={showCreateProduct} closeProductType={onClose} />}
      />} */}
    </Modal>
  );
};
export default ProductTypeModal;
